import { categoryHasStockButPageDoesNot } from "../../../helpers/categoryHasStockButPageDoesNot";

const clientSideRedirect = response => {
  const { products, itemCount, redirectUrl } = response;

  if (redirectUrl) {
    window.location.href = redirectUrl;

    return;
  }

  if (
    categoryHasStockButPageDoesNot({
      itemCount,
      productsLength: products?.length
    })
  ) {
    const url = new URL(window.location.href);
    url.searchParams.delete("page");

    window.location.href = `${url.pathname}${url.search}`;
  }
};

export default clientSideRedirect;
